import type { EmbedSyncedDocModel } from '@blocksuite/affine-model';

import { BlockService } from '@blocksuite/block-std';

export class EmbedSyncedDocBlockService extends BlockService<EmbedSyncedDocModel> {}
